import { render, staticRenderFns } from "./XmlAuthenticator.vue?vue&type=template&id=4ed616ea&scoped=true&"
import script from "./XmlAuthenticator.vue?vue&type=script&lang=js&"
export * from "./XmlAuthenticator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed616ea",
  null
  
)

export default component.exports